import React from 'react';
type EmailSignatureProps = {
  name: string;
  title: string;
  address: string[];
  phone: string;
  email?: string;
  mobile?: string;
};
export function EmailSignature({
  name,
  title,
  address,
  phone,
  email,
  mobile
}: EmailSignatureProps) {
  const brandColor = '#00B5AD';
  const textColor = '#333333';
  const lightTextColor = '#666666';
  // Animated logo URL
  const animatedLogoUrl = 'https://cdn.magicpatterns.com/uploads/81vFS5B2xcJZqmc6jSmaUJ/ezgif.com-animated-gif-maker.gif';
  // Lotus flower SVG as data URI for email compatibility
  const lotusFlowerDataUri = `data:image/svg+xml,%3Csvg width='32' height='20' viewBox='0 0 40 24' fill='rgba(255,255,255,0.3)' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20 2C20 2 16 6 16 10C16 12 17 14 20 14C23 14 24 12 24 10C24 6 20 2 20 2Z'/%3E%3Cpath d='M12 6C12 6 10 10 12 14C13 16 15 16 17 14C15 12 14 10 12 6Z'/%3E%3Cpath d='M28 6C28 6 30 10 28 14C27 16 25 16 23 14C25 12 26 10 28 6Z'/%3E%3Cpath d='M6 10C6 10 6 14 10 16C12 17 14 15 14 13C12 12 8 12 6 10Z'/%3E%3Cpath d='M34 10C34 10 34 14 30 16C28 17 26 15 26 13C28 12 32 12 34 10Z'/%3E%3C/svg%3E`;
  return <table cellPadding="0" cellSpacing="0" style={{
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '14px',
    lineHeight: '1.5',
    color: textColor,
    width: '100%',
    maxWidth: '600px',
    borderCollapse: 'collapse'
  }} data-id="element-28">
      <tbody data-id="element-29">
        {/* Main content row */}
        <tr data-id="element-30">
          {/* Logo column - 30% width */}
          <td style={{
          width: '30%',
          verticalAlign: 'middle',
          paddingRight: '20px'
        }} data-id="element-31">
            <a href="https://francedecoration.fr" target="_blank" rel="noopener noreferrer" style={{
            textDecoration: 'none',
            display: 'block'
          }} data-id="element-32">
              <img src={animatedLogoUrl} alt="France Décoration" style={{
              display: 'block',
              width: '100%',
              height: 'auto'
            }} data-id="element-33" />
            </a>
          </td>

          {/* Vertical divider */}
          <td style={{
          width: '3px',
          backgroundColor: brandColor,
          verticalAlign: 'middle'
        }} data-id="element-34">
            &nbsp;
          </td>

          {/* Contact info column */}
          <td style={{
          verticalAlign: 'middle',
          paddingLeft: '20px'
        }} data-id="element-35">
            {/* Name */}
            <p style={{
            margin: '0 0 2px 0',
            fontSize: '18px',
            fontWeight: 'bold',
            color: brandColor,
            letterSpacing: '0.5px'
          }} data-id="element-36">
              {name}
            </p>

            {/* Title */}
            <p style={{
            margin: '0 0 16px 0',
            fontSize: '14px',
            color: textColor,
            fontWeight: '500'
          }} data-id="element-37">
              {title}
            </p>

            {/* Address */}
            <div style={{
            marginBottom: '12px'
          }} data-id="element-38">
              {address.map((line, index) => <p key={index} style={{
              margin: '0',
              fontSize: '13px',
              color: lightTextColor,
              lineHeight: '1.6'
            }} data-id="element-39">
                  {line}
                </p>)}
            </div>

            {/* Phone */}
            <p style={{
            margin: '0 0 4px 0',
            fontSize: '13px',
            color: textColor
          }} data-id="element-40">
              <span style={{
              color: lightTextColor
            }} data-id="element-41">
                Tél :{' '}
              </span>
              <a href={`tel:${phone.replace(/\./g, '')}`} style={{
              color: textColor,
              textDecoration: 'none',
              fontWeight: '500'
            }} data-id="element-42">
                {phone}
              </a>
            </p>

            {/* Mobile (optional) */}
            {mobile && <p style={{
            margin: '0 0 4px 0',
            fontSize: '13px',
            color: textColor
          }} data-id="element-43">
                <span style={{
              color: lightTextColor
            }} data-id="element-44">
                  Mobile :{' '}
                </span>
                <a href={`tel:${mobile.replace(/\./g, '')}`} style={{
              color: textColor,
              textDecoration: 'none',
              fontWeight: '500'
            }} data-id="element-45">
                  {mobile}
                </a>
              </p>}

            {/* Email (optional) */}
            {email && <p style={{
            margin: '0 0 4px 0',
            fontSize: '13px',
            color: textColor
          }} data-id="element-46">
                <a href={`mailto:${email}`} style={{
              color: brandColor,
              textDecoration: 'none'
            }} data-id="element-47">
                  {email}
                </a>
              </p>}

            {/* Website */}
            <p style={{
            margin: '8px 0 0 0',
            fontSize: '13px'
          }} data-id="element-48">
              <a href="https://francedecoration.fr" target="_blank" rel="noopener noreferrer" style={{
              color: brandColor,
              textDecoration: 'none',
              fontWeight: '500'
            }} data-id="element-49">
                www.francedecoration.fr
              </a>
            </p>
          </td>
        </tr>

        {/* Spacer row */}
        <tr data-id="element-50">
          <td colSpan={3} style={{
          height: '20px'
        }} data-id="element-51">
            &nbsp;
          </td>
        </tr>

        {/* Decorative lotus border row */}
        <tr data-id="element-52">
          <td colSpan={3} style={{
          backgroundColor: brandColor,
          padding: '12px 16px',
          textAlign: 'center'
        }} data-id="element-53">
            <table cellPadding="0" cellSpacing="0" style={{
            margin: '0 auto',
            borderCollapse: 'collapse'
          }} data-id="element-54">
              <tbody data-id="element-55">
                <tr data-id="element-56">
                  {[...Array(12)].map((_, i) => <td key={i} style={{
                  padding: '0 4px'
                }} data-id="element-57">
                      <img src={lotusFlowerDataUri} alt="" width="32" height="20" style={{
                    display: 'block',
                    border: 'none'
                  }} data-id="element-58" />
                    </td>)}
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>;
}
// Compact version - maintains visual consistency with full version but more condensed
export function EmailSignatureCompact({
  name,
  title,
  address,
  phone,
  email,
  mobile
}: EmailSignatureProps) {
  const brandColor = '#00B5AD';
  const textColor = '#333333';
  const lightTextColor = '#666666';
  const animatedLogoUrl = 'https://cdn.magicpatterns.com/uploads/81vFS5B2xcJZqmc6jSmaUJ/ezgif.com-animated-gif-maker.gif';
  // Combine first two address lines for compact display
  const compactAddress = [`${address[0]}, ${address[1]}`, address[2]];
  return <table cellPadding="0" cellSpacing="0" style={{
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '14px',
    lineHeight: '1.5',
    color: textColor,
    maxWidth: '550px',
    borderCollapse: 'collapse'
  }} data-id="element-59">
      <tbody data-id="element-60">
        <tr data-id="element-61">
          {/* Logo */}
          <td style={{
          verticalAlign: 'middle',
          paddingRight: '16px'
        }} data-id="element-62">
            <a href="https://francedecoration.fr" target="_blank" rel="noopener noreferrer" style={{
            textDecoration: 'none'
          }} data-id="element-63">
              <img src={animatedLogoUrl} alt="France Décoration" width="110" style={{
              display: 'block',
              maxWidth: '110px',
              height: 'auto'
            }} data-id="element-64" />
            </a>
          </td>

          {/* Divider */}
          <td style={{
          width: '3px',
          backgroundColor: brandColor,
          verticalAlign: 'middle'
        }} data-id="element-65">
            &nbsp;
          </td>

          {/* Info */}
          <td style={{
          verticalAlign: 'middle',
          paddingLeft: '16px'
        }} data-id="element-66">
            {/* Name */}
            <p style={{
            margin: '0 0 2px 0',
            fontSize: '17px',
            fontWeight: 'bold',
            color: brandColor,
            letterSpacing: '0.5px'
          }} data-id="element-67">
              {name}
            </p>

            {/* Title */}
            <p style={{
            margin: '0 0 8px 0',
            fontSize: '13px',
            color: textColor,
            fontWeight: '500'
          }} data-id="element-68">
              {title}
            </p>

            {/* Address - 2 lines */}
            <div style={{
            marginBottom: '8px'
          }} data-id="element-69">
              {compactAddress.map((line, index) => <p key={index} style={{
              margin: '0',
              fontSize: '11px',
              color: lightTextColor,
              lineHeight: '1.5'
            }} data-id="element-70">
                  {line}
                </p>)}
            </div>

            {/* Contact info condensed */}
            <p style={{
            margin: '0 0 3px 0',
            fontSize: '12px',
            color: textColor
          }} data-id="element-71">
              <span style={{
              color: lightTextColor
            }} data-id="element-72">
                Tél :{' '}
              </span>
              <a href={`tel:${phone.replace(/\./g, '')}`} style={{
              color: textColor,
              textDecoration: 'none',
              fontWeight: '500'
            }} data-id="element-73">
                {phone}
              </a>
              {mobile && <>
                  {' | '}
                  <span style={{
                color: lightTextColor
              }} data-id="element-74">
                    Mobile :{' '}
                  </span>
                  <a href={`tel:${mobile.replace(/\./g, '')}`} style={{
                color: textColor,
                textDecoration: 'none',
                fontWeight: '500'
              }} data-id="element-75">
                    {mobile}
                  </a>
                </>}
            </p>

            {/* Email */}
            {email && <p style={{
            margin: '0 0 3px 0',
            fontSize: '12px'
          }} data-id="element-76">
                <a href={`mailto:${email}`} style={{
              color: brandColor,
              textDecoration: 'none'
            }} data-id="element-77">
                  {email}
                </a>
              </p>}

            {/* Website */}
            <p style={{
            margin: '0',
            fontSize: '12px'
          }} data-id="element-78">
              <a href="https://francedecoration.fr" target="_blank" rel="noopener noreferrer" style={{
              color: brandColor,
              textDecoration: 'none',
              fontWeight: '500'
            }} data-id="element-79">
                www.francedecoration.fr
              </a>
            </p>
          </td>
        </tr>
      </tbody>
    </table>;
}